import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import imgLogo from "assets/images/logo.png";
import imgSuccess from "assets/images/success.png";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { SuccessOk } from "configs/statusCode";
// Redux
import { Link } from "react-router-dom";
import { AvField, AvForm } from "availity-reactstrap-validation";
import AuthService from "services/SalesDeveloper/AuthService";
import "./login.scss";
import { salesDeveloperPrefix } from "configs/routePrefix";
import { API_BASE_URL_ENV } from "helpers/common";
import { toast } from "react-toastify";

const apiResetPasswordEndpoint =
  API_BASE_URL_ENV() + "/sales-developer/user/forget-password";

const ForgetPassword = (props) => {
  const [codeSent, setCodeSent] = useState(false)
  const [email, setEmail] = useState(false)
  const [loading, setLoading] = useState(false)



  const handleValidSubmit = async (event, values) => {
    setLoading(true)

    try {
      AuthService.forgetPassword(apiResetPasswordEndpoint, values).then(response => {
        // toast.success(`${response.success} , Please Check Your Email`);
        setCodeSent(true)
      })
    } catch (error) {
      setLoading(false)
      toast.error(error)
    }
  };
  useEffect(() => {
    setCodeSent(false)

  }, [])
  return (
    <React.Fragment>
      <MetaTags>
        <title>Reset Password</title>
      </MetaTags>
      <div className='account-pages'>
        <div className="bgImage">
          <Container fluid>
            <Row className='justify-content-center text-left' dir='rtl'>
              <Col md={8} lg={7} xl={6} className='p-lg-0 p-md-0' dir='ltr'>
                {!codeSent ? <Card className='overflow-hidden mt-5 mb-0'>
                  <CardBody className="text-center">
                    <img src={imgLogo} className='mt-3' />
                    <p className='fw-bold font-size-18 fw-bold pt-2 mb-2'>Forgot your password?</p>
                    <p className="textMuted font-size-13">Use you email address and password to can login</p>
                    <div className='p-2 pb-3'>
                      <AvForm
                        className='form-horizontal formWithLabel'
                        onValidSubmit={(e, v) => {
                          handleValidSubmit(e, v);
                        }}>
                        <div className='mb-3'>
                          <AvField
                            name='email'
                            label='Email Address'
                            className='form-control'
                            placeholder='Enter your Email Address'
                            type='email'
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value)
                            }}
                            required
                          />
                        </div>

                        <div className='mt-4 d-grid'>
                          <button
                            className='btn btn-success w-100 btnHeight'
                            disabled={loading ? true: false}
                            type='submit'>
                            Send Verification Code
                          </button>
                        </div>
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
                  : <Card className='overflow-hidden mt-5 mb-3'>
                    <CardBody className="text-center">
                      <img src={imgSuccess} className='mt-3 img-fluid' />
                      <p className='fw-bold font-size-18 fw-bold pt-3 mb-2'>Verification Code Send Succseffully </p>
                      <p className="textMuted font-size-13">We Have Sent an email to <b>{email}</b></p>
                      <button className="btn btn-success w-100 mt-3" onClick={() => {
                        props.history.push(`${salesDeveloperPrefix}/login`); 
                      }}>Done</button>
                    </CardBody>
                  </Card>}
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForgetPassword;
